import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import AppLayout from "./components/layout/AppLayout";
import HomePage from "./pages/HomePage";
import QuoteFormPage from "./pages/QuoteFormPage";
import SettingsPage from "./pages/SettingsPage";
import PublicQuotePage from "./pages/PublicQuotePage";
import LoginPage from "./pages/LoginPage";
import UsersPage from "./pages/UsersPage";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Loader2 } from "lucide-react";

const ProtectedLayout = () => {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="animate-spin text-slate-400" size={28} />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <AppLayout />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/p/:token" element={<PublicQuotePage />} />
            <Route element={<ProtectedLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/cotizacion/nueva" element={<QuoteFormPage />} />
              <Route path="/cotizacion/:id" element={<QuoteFormPage />} />
              <Route path="/config" element={<SettingsPage />} />
              <Route path="/usuarios" element={<UsersPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
